// extracted by mini-css-extract-plugin
export default {"headerCell":"SimpleTableHeader_headerCell__ZG+vu","rowStyle":"SimpleTableHeader_rowStyle__7vGVD"};